import React from 'react';

export const RATING_COLORS = {
  A: { bg: '#00bf63', tintBg: 'rgba(0,191,99,0.12)',  tintText: '#006e3a', border: 'rgba(0,191,99,0.40)' },
  B: { bg: '#c7de26', tintBg: 'rgba(199,222,38,0.14)', tintText: '#5a6a00', border: 'rgba(199,222,38,0.50)' },
  C: { bg: '#f6cc27', tintBg: 'rgba(246,204,39,0.14)', tintText: '#7a6400', border: 'rgba(246,204,39,0.50)' },
  D: { bg: '#fc7c2c', tintBg: 'rgba(252,124,44,0.12)', tintText: '#a04000', border: 'rgba(252,124,44,0.40)' },
  E: { bg: '#ff5a3d', tintBg: 'rgba(255,90,61,0.12)',  tintText: '#b01c00', border: 'rgba(255,90,61,0.40)' },
  F: { bg: '#ff1b3b', tintBg: 'rgba(255,27,59,0.12)',  tintText: '#aa0020', border: 'rgba(255,27,59,0.40)' },
  G: { bg: '#c0003f', tintBg: 'rgba(192,0,63,0.12)',   tintText: '#7a0028', border: 'rgba(192,0,63,0.40)' },
};

export const ratingLabels = { A: 'Très bonne', B: 'Bonne', C: 'Moyenne', D: 'Passable', E: 'Mauvaise', F: 'Très mauvaise', G: 'Critique' };

export const RatingBadge = ({ letter, large }) => {
  if (!letter) return <span style={{ color: 'var(--color-on-surface-var)', fontSize: '0.875rem' }}>—</span>;
  const c = RATING_COLORS[letter] || { bg: '#94a3b8' };
  const size = large ? 48 : 30;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      width: size, height: size, borderRadius: large ? 14 : 8,
      background: c.bg, color: ['B', 'C'].includes(letter) ? '#181c22' : '#ffffff',
      fontSize: large ? '1.25rem' : '0.75rem', fontWeight: 700, flexShrink: 0,
    }}>{letter}</span>
  );
};

export default RatingBadge;
